import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cta: 'Confirm my information',
    labels: {
      birthCountry: 'Country of birth',
      birthDate: 'Date of birth',
      birthPlace: 'Birth place',
      firstName: 'First name(s)',
      lastName: 'Last name',
      legalTitle: 'Legal title',
      nationality: 'Nationality',
    },
    sections: {
      additionalInformation: 'Additional information',
      address: 'Postal address',
      personalInformation: 'Personal information',
    },
    title: 'Your personal details',
  },
  fr: {
    cta: 'Confirmer mes informations',
    labels: {
      birthCountry: 'Pays de naissance',
      birthDate: 'Date de naissance',
      birthPlace: 'Lieu de naissance',
      firstName: 'Prénom(s)',
      lastName: 'Nom de naissance',
      legalTitle: 'Civilité',
      nationality: 'Nationalité',
    },
    sections: {
      additionalInformation: 'Informations supplémentaires',
      address: 'Adresse postale',
      personalInformation: 'Informations d’identité',
    },
    title: 'Vos informations personnelles',
  },
} as const);
